<template>
    <div class="dropdown grouped-multi-select-vue" ref="dropDownElement">
        <button
            :class="`btn input-border bg-white ps-2 pe-1 ${classes}`"
            type="button"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            :disabled="isDisabled"
        >
            <span>{{ getButtonText }}</span>
            <span class="dropdown-toggle ps-2"></span>
        </button>
        <div class="dropdown-menu" ref="dropDownMenu">
            <div class="input-group p-1">
                <input
                    type="text"
                    ref="searchInput"
                    class="form-control"
                    v-model="search"
                    :placeholder="getPlaceholderText"
                />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <i class="fas fa-search"></i>
                    </div>
                </div>
            </div>
            <div class="dropdown-item p-0 my-1" v-if="!search">
                <div class="form-check ps-2 d-flex justify-content-between align-items-center select-all-row">
                    <label class="form-check-label ms-2 select-all-option">
                        <input
                            class="me-1"
                            type="checkbox"
                            @change.prevent="toggleAllSelection()"
                            :checked="selectedOptions.length === getDropDownOptionsLength"
                        />
                        Select All
                    </label>
                    <label v-if="showPrimaryBranch" class="form-check-label me-2 primary-branch-option">
                        <input
                            class="me-1"
                            type="checkbox"
                            @change.prevent="togglePrimaryLocationFilter()"
                            :checked="isPrimaryLocationFilter"
                        />
                        Primary Branch
                    </label>
                </div>
            </div>
            <div class="dropdown-divider" v-if="!search"></div>
            <div ref="filterContainer" class="content">
                <div v-for="(groupName, index) of Object.keys(filteredOptions)" :key="groupName">
                    <label
                        class="btn fw-bold d-flex justify-content-start align-items-start"
                        v-if="groupName && filteredOptions[groupName].length > 0"
                        :for="`group-${groupName}`"
                    >
                        <input
                            type="checkbox"
                            class="mt-1"
                            :id="`group-${groupName}`"
                            @change.prevent="toggleGroupSelected(groupName)"
                            :checked="allGroupElementsSelected(groupName)"
                        />
                        <span class="m-0 text-start ms-2">
                            {{ getProviderName(groupName) }}
                            <ProductPill
                                class="fw-normal font-size-xs badge badge-pill ps-2 ms-1"
                                :product-id="getProviderApplication(groupName)"
                            ></ProductPill>
                        </span>
                    </label>
                    <div class="dropdown-item p-0 ps-2 my-1" v-for="option in filteredOptions[groupName]" :key="option">
                        <div class="form-check ps-0 ms-2">
                            <label class="form-check-label ms-2" :for="`option-${option}`">
                                <input
                                    class="mx-1"
                                    type="checkbox"
                                    :id="`option-${option}`"
                                    @change.prevent="toggleSingleSelection(option)"
                                    :checked="selectedOptions.includes(option)"
                                />
                                {{ optionEnumMap.getEnumName(option) }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dropdown-divider"></div>
            <div class="px-1">
                <button class="btn btn-outline-dark w-100" @click="closeDropDown()">Close</button>
            </div>
        </div>
    </div>
</template>

<style src="./GroupedMultiSelect.scss"></style>

<script src="./GroupedMultiSelect"></script>
